import { SERVER_API } from "../../Constant";
import axios from "axios";

export const FetchAgingStock_api = async () => {
  try {
    const response = await axios.get(
      `${SERVER_API}/Stock/fetch_aging_stock.php`,
    );
    return response.data;
  } catch (error) {
    console.error("Fetch aging stock failed:", error);
    return { error: "Fetch aging stock failed" };
  }
};
